<template>
  <a-modal
    class="data-dialog"
    :title="editing ? '编辑数据' : '数据详情'"
    width="1200px"
    v-model:visible="visible"
    destroyOnClose
    :footer="false">
    <a-tabs @change="changeTab" v-model:activeKey="activeTab">
      <a-tab-pane key="1" tab="原图">
        <img class="large-pic"
          :src="appConfig.baseImgUrl + currentDataItem.accessSrc"
          alt="数据图片">
      </a-tab-pane>
      <a-tab-pane v-if="loading || (polygonData && polygonData.shapes)" key="2" :disabled="loading && !polygonData">
        <template #tab>
          <span>
            <LoadingOutlined v-if="loading"/>
            多边形
          </span>
        </template>
        <BoxLabel ref="polygonLabel"
          type="polygon"
          :labelData="polygonData"
          @save="arg => saveXY(arg, 'polygon')"
          :currentDataItem="currentDataItem">
        </BoxLabel>
      </a-tab-pane>
      <a-tab-pane v-if="loading || objDetData" key="3" :disabled="loading && !objDetData">
        <template #tab>
          <span>
            <LoadingOutlined v-if="loading"/>
            目标检测标注&矩形框标注
          </span>
        </template>
        <BoxLabel ref="boxLabel"
          type="box"
          :labelData="objDetData"
          @save="arg => saveXY(arg, 'box')"
          :currentDataItem="currentDataItem">
        </BoxLabel>
      </a-tab-pane>
      <!-- <a-tab-pane key="4" tab="分类标注" force-render></a-tab-pane>
      <a-tab-pane key="5" tab="实例分割标注" force-render></a-tab-pane>
      <a-tab-pane key="6" tab="全景分割" force-render></a-tab-pane>
      <a-tab-pane key="7" tab="语义分割" force-render></a-tab-pane>
      <a-tab-pane key="8" tab="其他标注" force-render></a-tab-pane> -->
    </a-tabs>
    <div v-if="activeTab === '1'">
      <a-form class="data-detail-form">
        <div class="form-col">
          <a-form-item label="上传ID">
            <span>{{ currentDataItem.uploadRecordId }}</span>
          </a-form-item>
          <a-form-item label="上传人">
            <span>{{ getUserName(currentDataItem.createUserId) }}</span>
          </a-form-item>
          <a-form-item label="上传时间">
            <span>{{ currentDataItem.createTime }}</span>
          </a-form-item>
          <a-form-item label="文件大小">
            <span>{{ currentDataItem.size }}</span>
          </a-form-item>
          <a-form-item label="添加数据集">
            <span>{{ successFailure(currentDataItem.existDatasetState) }}</span>
          </a-form-item>
          <a-form-item label="最后更新人">
            <span>{{ getUserName(currentDataItem.updateUserId) }}</span>
          </a-form-item>
          <a-form-item label="最后更新时间">
            <span>{{ getDateTime(currentDataItem.updateTime) || '未更新' }}</span>
          </a-form-item>
          <a-form-item label="数据属性">
            <a-tree-select
              v-if="editing"
              v-model:value="attrValue"
              style="width: 200px"
              treeNodeLabelProp="chineseInstructions"
              :tree-data="attrTree"
              tree-checkable
              search-placeholder="请选择"
            />
            <div v-else>
              <p v-for="(info, index) in valueAndParent" :key="index">
                {{ info.parentName }}：{{ info.children.map(c => c.chineseInstructions).join('，') }}
              </p>
            </div>
          </a-form-item>
          <a-form-item label="tag标签">
            <a-select
              v-if="editing"
              mode="multiple"
              v-model:value="tagIds"
              style="width: 120px"
              placeholder="请选择">
              <a-select-option v-for="tag in allTags"
                :key="tag.id">
                {{ tag.chineseInstructions }}
              </a-select-option>
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <a-divider style="margin: 4px 0;" />
                <div
                  style="padding: 4px 8px; cursor: pointer;"
                  @mousedown="e => e.preventDefault()"
                  @click="addTagToAllTags">
                  新建tag
                </div>
              </template>
            </a-select>
            <p v-else>{{ initialTags.map(i => getTagName(i.tagId)).join('，') }}</p>
          </a-form-item>
        </div>
        <div class="form-col">
          <a-form-item label="目标检测标注&矩形框标注">
            <span>{{ objDetData ? '有' : '无' }}</span>
          </a-form-item>
          <a-form-item label="多边形标注">
            <span>{{ polygonData && polygonData.shapes ? '有' : '无' }}</span>
          </a-form-item>
        </div>
        <div class="form-col">
          <a-form-item label="自动目标检测标注&矩形框标注">
            <span>{{ successFailure(currentDataItem.autoObjectDetectionTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动分类标注">
            <span>{{ successFailure(currentDataItem.autoClassficationTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动全景分割标注">
            <span>{{ successFailure(currentDataItem.autoPanopticSegmentationTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动实例分割标注">
            <span>{{ successFailure(currentDataItem.autoInstanceSegmentationTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动语义分割标注">
            <span>{{ successFailure(currentDataItem.autoSemanticSegmentationTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动多边形标注">
            <span>{{ successFailure(currentDataItem.autoPolygonTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动tag标注">
            <span>{{ successFailure(currentDataItem.autoTagAnnotationTaskState) }}</span>
          </a-form-item>
          <a-form-item label="自动其他标注">
            <span>{{ successFailure(currentDataItem.autoOtherAnnotationTaskState) }}</span>
          </a-form-item>
        </div>
      </a-form>
      <div class="ctrl-wrap" v-if="showDataSetBtn">
        <a-button v-if="!editing" type="primary" @click="editing = true">编辑</a-button>
        <a-button v-if="editing" @click="cancel">取消</a-button>
        <a-button v-if="editing" type="primary" @click="submit">保存</a-button>
      </div>
      <a-modal v-model:visible="newTagModalVisible" title="新建tag" @ok="confirmAddToAllTags">
        <a-input v-model:value="newTagName" autocomplete="off"></a-input>
      </a-modal>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { getDateTime, successFailure2, getUserName } from '@/filters'
import {
  updateDataItem, getItemTagLabel, addItemTagLabel, deleteItemTagLabel,
  getItemBoxLabel, updateItemBoxLabel
} from '@/api/dataItem'
import { addTagLabel } from '@/api/tagLabel'
import { getAttrOfItem, addAttrToItem, deleteAttrFromItem, getItemValueById, getItemValueParent } from '@/api/dataAttr'
import BoxLabel from './BoxLabel'
const convertor = require('xml-js')
export default {
  props: {
    currentDataItem: {
      type: Object,
      default: () => {}
    },
    allTags: {
      type: Array,
      default: () => []
    },
    attrTree: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BoxLabel,
    LoadingOutlined,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes
    }
  },
  data () {
    return {
      loading: false,
      activeTab: '1',
      visible: false,
      editing: false,
      form: {
        classficationTaskState: '',
        instanceSegmentationTaskState: '',
        objectDetectionTaskState: '',
        panopticSegmentationTaskState: '',
        polygonTaskState: '',
        semanticSegmentationTaskState: '',
        tagAnnotationTaskState: '',
        otherAnnotationTaskState: ''
      },
      boxCompInit: false,
      polygonCompInit: false,
      initialTags: [],
      tagIds: [],
      newTagModalVisible: false,
      newTagName: '',
      initialAttrValue: [],
      attrValue: [],
      valueAndParent: [],
      itemXYData: {},
      polygonData: null,
      objDetData: null
    }
  },
  computed: {
    ...mapState(['appConfig', 'currentRole']),
    showDataSetBtn () {
      const invalid = ['9', '10', '11']
      return this.currentRole && invalid.indexOf(this.currentRole.roleId) === -1
    }
  },
  watch: {
    visible (val) {
      if (!val) {
        this.activeTab = '1'
        console.log('leave')
        if (this.boxCompInit) {
          this.boxCompInit = false
          this.$refs.boxLabel.leave()
        }
        if (this.polygonCompInit) {
          this.polygonCompInit = false
          this.$refs.polygonLabel.leave()
        }
      }
    }
  },
  methods: {
    getDateTime,
    successFailure: successFailure2,
    getUserName,
    changeTab (n) {
      if (n === '2' && !this.polygonCompInit) {
        this.$nextTick(() => {
          this.$refs.polygonLabel.init()
          this.polygonCompInit = true
        })
      } else if (n === '3' && !this.boxCompInit) {
        this.$nextTick(() => {
          this.$refs.boxLabel.init()
          this.boxCompInit = true
        })
      }
    },
    open () {
      this.visible = true
      this.activeTab = '1'
      this.editing = false
      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => {
          this.form[key] = this.currentDataItem[key]
        })
        this.getDataAttr()
        this.getTagLabel()
        this.getItemAndXY()
      })
    },
    cancel () {
      this.editing = false
      Object.keys(this.form).forEach(key => {
        this.form[key] = this.currentDataItem[key]
      })
    },
    getDataAttr () {
      this.attrValue = []
      getAttrOfItem(this.currentDataItem.id).then(res => {
        const data = res.data.map.data.rows
        if (!data.length || data[0].itemId !== this.currentDataItem.id) {
          console.log('返回返回')
          return
        }
        this.initialAttrValue = data
        this.attrValue = this.initialAttrValue.map(i => i.itemValueId)
        this.getValueAndParent()
      })
    },
    async getValueAndParent () {
      this.valueAndParent = []
      for (const id of this.attrValue) {
        const info = await this.getAttrKeyValue(id)
        if (!info) continue
        const exist = this.valueAndParent.find(i => i.parentId === info.parent.id)
        if (exist) {
          exist.children.push(info.itemValue)
        } else {
          this.valueAndParent.push({
            parentId: info.parent.id,
            parentName: info.parent.chineseInstructions,
            children: [info.itemValue]
          })
        }
      }
    },
    async getAttrKeyValue (itemValueId) {
      const res1 = await getItemValueById(itemValueId)
      const itemValue = res1.data.map.data.rows[0]
      if (!itemValue) return
      const res2 = await getItemValueParent(itemValue)
      const parent = res2.data.map.data.rows[0]
      if (!parent) return
      return {
        itemValue, parent
      }
      // get itemValue name
      // get parent name
    },
    async handleAttrChange () {
      for (const item of this.initialAttrValue) {
        if (this.attrValue.indexOf(item.itemValueId) === -1) {
          await deleteAttrFromItem(item.id)
        }
      }
      for (const i of this.attrValue) {
        if (!this.initialAttrValue.some(item => item.itemValueId === i)) {
          await addAttrToItem({
            itemId: this.currentDataItem.id,
            itemValueId: i
          })
        }
      }
    },
    async submit () {
      const params = {
        id: this.currentDataItem.id
        // ...this.form
      }
      await this.handleAttrChange()
      await this.handleTagChange()
      updateDataItem(params).then(res => {
        this.$emit('update')
        this.$message.success('已保存')
        this.visible = false
      })
    },
    getTagLabel () {
      this.tagIds = []
      getItemTagLabel(this.currentDataItem.id).then(res => {
        const data = res.data.map.data.rows
        this.initialTags = data
        this.tagIds = data.map(i => i.tagId)
      })
    },
    getTagName (id) {
      const tag = this.allTags.find(t => t.id === id)
      return tag ? tag.chineseInstructions : ''
    },
    async handleTagChange () {
      for (const item of this.initialTags) {
        if (this.tagIds.indexOf(item.tagId) === -1) {
          await deleteItemTagLabel(item.id)
        }
      }
      for (const i of this.tagIds) {
        if (!this.initialTags.some(item => item.tagId === i)) {
          await addItemTagLabel({
            itemId: this.currentDataItem.id,
            tagId: i
          })
        }
      }
    },
    // 添加至allTags
    addTagToAllTags () {
      this.newTagName = ''
      this.newTagModalVisible = true
    },
    confirmAddToAllTags () {
      if (!this.newTagName) return
      addTagLabel({
        chineseInstructions: this.newTagName
      }).finally(res => {
        this.newTagModalVisible = false
        this.$emit('updateTags')
      })
    },
    getItemAndXY () {
      this.loading = true
      this.itemXYData = {}
      this.polygonData = null
      this.objDetData = null
      getItemBoxLabel(this.currentDataItem.id, 1).then(res => {
        const data = res.data.map.data.rows[0]
        this.itemXYData = data
        let polygonData = null
        let objDetData = null
        if (data.polygon) {
          try {
            polygonData = JSON.parse(data.polygon)
          } catch {
            console.error('解析polygon失败 ' + data.id)
          }
        }
        if (data.objectDetection) {
          try {
            const str = convertor.xml2json(
              data.objectDetection,
              {
                compact: true,
                nativeType: true
              }
            )
            objDetData = JSON.parse(str)
          } catch {
            console.error('解析objectDetection失败 ' + data.id)
          }
        }
        this.polygonData = polygonData
        this.objDetData = objDetData
      }).finally(() => {
        this.loading = false
      })
    },
    saveXY (data, type) {
      let str = ''
      const params = {
        id: this.itemXYData.id
      }
      if (type === 'polygon') {
        str = JSON.stringify(data)
        params.polygon = str
      } else if (type === 'box') {
        str = convertor.json2xml(data, {
          compact: true,
          spaces: 0,
          fullTagEmptyElement: true
        })
        params.objectDetection = str
      }
      updateItemBoxLabel(params).then(res => {
        updateDataItem({
          id: this.currentDataItem.id
        }).then(res => {
          this.$message.success('已保存')
        })
      })
    }
  }
}
</script>
<style lang="less">
.data-dialog {
  .data-detail-form {
    margin-top: 10px;
    display: flex; flex-wrap: wrap;
    .form-col {
      width: 33%;
      .ant-form-item {
        margin: 0;
        .ant-select {
          width: 160px;
        }
      }
    }
  }
  .ctrl-wrap {
    text-align: right;
    .ant-btn {
      margin-left: 10px;
    }
  }
  .large-pic {
    display: block;
    width: 100%; min-height: 300px;
    background: #ccc;
  }
  .label-wrap {
    display: flex; align-items: flex-start;
    .half-pic {
      display: block;
      width: 50%; min-height: 300px;
      background: #ccc;
    }
    .label-ctrl {
      width: 50%;
      padding: 0 20px; box-sizing: border-box;
      .add-tag {
        margin-top: 10px;
        .ant-btn {
          margin-left: 10px;
        }
      }
      .tag-item-wrap {
        display: flex; flex-wrap: wrap;
        .tag-item{
          position: relative;
          background: #ddd;
          height: 40px;  line-height: 40px;
          padding: 0 20px;
          margin: 10px 10px 0 0;
          .close {
            position: absolute; top: 0; right: 0;
            width: 15px; height: 15px; line-height: 15px;
            text-align: center; background: rgba(200, 50, 50, 1); color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
